import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7562 4.09302C18.056 3.98922 18.379 3.9719 18.6882 4.04302C18.9975 4.11415 19.2804 4.27085 19.5048 4.49521C19.7292 4.71958 19.8859 5.00254 19.957 5.31177C20.0281 5.62099 20.0108 5.94398 19.907 6.24383L14.8467 20.8623C14.7301 21.1992 14.5099 21.4907 14.2177 21.695C13.9255 21.8993 13.5761 22.0059 13.2196 21.9997C12.8631 21.9935 12.5177 21.8748 12.2327 21.6605C11.9478 21.4462 11.7379 21.1473 11.633 20.8065L9.64725 14.3528L3.19353 12.367C2.85274 12.2621 2.55382 12.0522 2.33951 11.7673C2.12519 11.4823 2.00645 11.1369 2.00026 10.7804C1.99406 10.4239 2.10073 10.0745 2.30502 9.7823C2.5093 9.49007 2.80075 9.26989 3.13769 9.15326L17.7562 4.09302Z"
        fill={colorValue}
      />
    </svg>
  );
};
